// Module
var code = "<label class=\"switch\"> <input type=\"checkbox\" ng-model=\"vm.checked\" ng-click=\"$event.stopPropagation(); $event.preventDefault();\"> <span class=\"slider round\"></span> </label> ";
// Exports
module.exports = code;